<template>
  <IconWrapper :dense="dense">
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.35259 15.75H14.6476C15.8026 15.75 16.5226 14.4975 15.9451 13.5L10.2976 3.74251C9.72009 2.74501 8.28009 2.74501 7.70259 3.74251L2.05509 13.5C1.47759 14.4975 2.19759 15.75 3.35259 15.75ZM9.00009 10.5C8.58759 10.5 8.25009 10.1625 8.25009 9.75001V8.25001C8.25009 7.83751 8.58759 7.50001 9.00009 7.50001C9.41259 7.50001 9.75009 7.83751 9.75009 8.25001V9.75001C9.75009 10.1625 9.41259 10.5 9.00009 10.5ZM9.75009 13.5H8.25009V12H9.75009V13.5Z"
      />
    </svg>
  </IconWrapper>
</template>

<script>
import IconWrapper from './IconWrapper'

export default {
  components: {
    IconWrapper
  },

  props: {
    dense: Boolean
  }
}
</script>

<style lang="scss" scoped>
svg path {
  fill: var(--r-warning-1);
}
</style>
